const facebookIcon = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.576 25.792a10.114 10.114 0 0 1-3.084.01v-6.975h-2.558v-2.869h2.558v-2.025c.068-3.798 2.526-4.472 5.972-3.798.013.466.005.826-.003 1.186s-.016.72-.003 1.186c-2.508-.177-2.932.245-2.883 2.439v1.012h2.748l-.424 2.87h-2.323v6.964Zm0 0C22.35 25.039 26 20.922 26 15.957 26 10.458 21.523 6 16 6S6 10.458 6 15.957c0 4.99 3.685 9.122 8.492 9.845V26h3.084v-.208Z"
      fill="#fff"
    />
  </svg>
);

const facebookIconLight = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.576 25.792a10.114 10.114 0 0 1-3.084.01v-6.975h-2.558v-2.869h2.558v-2.025c.068-3.798 2.526-4.472 5.972-3.798.013.466.005.826-.003 1.186s-.016.72-.003 1.186c-2.508-.177-2.932.245-2.883 2.439v1.012h2.748l-.424 2.87h-2.323v6.964Zm0 0C22.35 25.039 26 20.922 26 15.957 26 10.458 21.523 6 16 6S6 10.458 6 15.957c0 4.99 3.685 9.122 8.492 9.845V26h3.084v-.208Z"
      fill="#000"
    />
  </svg>
);

const whatsappIcon = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.871 6.002c-5.28.095-9.607 4.363-9.772 9.643a9.92 9.92 0 0 0 1.168 5.006.6.6 0 0 1 .053.439l-1.333 4.976a.118.118 0 0 0 .144.145l5.087-1.363a.59.59 0 0 1 .421.045 9.92 9.92 0 0 0 4.668 1.03c5.409-.134 9.755-4.633 9.71-10.044-.045-5.525-4.588-9.978-10.147-9.877h.002Zm.185 18.263a8.286 8.286 0 0 1-4.187-1.133.581.581 0 0 0-.447-.057l-1.81.486-1.133.303a.118.118 0 0 1-.145-.145l.298-1.113.47-1.755a.585.585 0 0 0-.074-.464 8.311 8.311 0 0 1-1.275-4.422 8.301 8.301 0 0 1 8.502-8.3c4.405.104 7.996 3.696 8.1 8.1a8.302 8.302 0 0 1-8.3 8.502v-.002Z"
      fill="#fff"
    />
    <path
      d="M21.096 18.81c0-.134 0-.412-.02-.462a.196.196 0 0 0-.032-.054.631.631 0 0 0-.224-.17l-2.037-.947a.257.257 0 0 0-.18-.017.618.618 0 0 0-.32.22l-.627.836c-.237.356-.68.287-1.2.003-.22-.105-.793-.49-.922-.587a10.925 10.925 0 0 1-.962-.838c-.113-.114-.575-.626-.711-.83-.475-.713-.269-.912-.238-.949l.664-.75c.096-.083.127-.338.076-.455l-.973-2.295a.29.29 0 0 0-.266-.175h-.509c-.297 0-.414.118-.53.177-.29.148-.482.34-.658.647a3.237 3.237 0 0 0-.412 1.607v.043c0 1.085.948 2.745 2.515 4.43.102.11.582.52.717.626.16.124 1.32 1.029 2.804 1.524.246.082.48.146.724.197.264.054.493.125.948.119.223-.004.495-.008.83-.12.356-.118.492-.209.713-.355.355-.237.593-.593.712-.83.053-.107.118-.356.118-.593v-.003Z"
      fill="#fff"
    />
  </svg>
);

const whatsappIconLight = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.871 6.002c-5.28.095-9.607 4.363-9.772 9.643a9.92 9.92 0 0 0 1.168 5.006.6.6 0 0 1 .053.439l-1.333 4.976a.118.118 0 0 0 .144.145l5.087-1.363a.59.59 0 0 1 .421.045 9.92 9.92 0 0 0 4.668 1.03c5.409-.134 9.755-4.633 9.71-10.044-.045-5.525-4.588-9.978-10.147-9.877h.002Zm.185 18.263a8.286 8.286 0 0 1-4.187-1.133.581.581 0 0 0-.447-.057l-1.81.486-1.133.303a.118.118 0 0 1-.145-.145l.298-1.113.47-1.755a.585.585 0 0 0-.074-.464 8.311 8.311 0 0 1-1.275-4.422 8.301 8.301 0 0 1 8.502-8.3c4.405.104 7.996 3.696 8.1 8.1a8.302 8.302 0 0 1-8.3 8.502v-.002Z"
      fill="#000"
    />
    <path
      d="M21.097 18.81c0-.134 0-.412-.02-.462a.196.196 0 0 0-.032-.054.631.631 0 0 0-.224-.17l-2.038-.947a.257.257 0 0 0-.18-.017.618.618 0 0 0-.32.22l-.626.836c-.238.356-.68.287-1.2.003-.22-.105-.793-.49-.922-.587a10.94 10.94 0 0 1-.962-.838c-.114-.114-.576-.626-.712-.83-.474-.713-.269-.912-.238-.949l.664-.75c.097-.083.127-.338.077-.455l-.973-2.295a.29.29 0 0 0-.266-.175h-.51c-.296 0-.414.118-.53.177-.289.148-.482.34-.658.647a3.237 3.237 0 0 0-.412 1.607v.043c0 1.085.948 2.745 2.516 4.43.101.11.582.52.716.626.16.124 1.321 1.029 2.804 1.524.247.082.48.146.725.197.263.054.492.125.948.119.223-.004.495-.008.83-.12.356-.118.492-.209.712-.355.356-.237.593-.593.712-.83.053-.107.119-.356.119-.593v-.003Z"
      fill="#000"
    />
  </svg>
);

const instagramIcon = (
  <svg width="32" height="33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.196 26.872H10.804C8.155 26.872 6 24.61 6 21.827v-9.91c0-2.782 2.155-5.045 4.804-5.045h10.392c2.649 0 4.804 2.263 4.804 5.045v9.91c0 2.782-2.155 5.045-4.804 5.045ZM10.804 8.39c-1.852 0-3.358 1.583-3.358 3.527v9.91c0 1.945 1.506 3.527 3.358 3.527h10.392c1.851 0 3.358-1.582 3.358-3.527v-9.91c0-1.944-1.506-3.527-3.358-3.527H10.804Z"
      fill="#fff"
    />
    <path
      d="M16 22.372c-2.9 0-5.26-2.478-5.26-5.524s2.36-5.523 5.26-5.523 5.26 2.477 5.26 5.523-2.36 5.524-5.26 5.524Zm0-9.53c-2.103 0-3.814 1.798-3.814 4.006 0 2.209 1.71 4.006 3.814 4.006 2.103 0 3.814-1.797 3.814-4.006 0-2.209-1.71-4.005-3.814-4.005ZM21.844 11.856c.472 0 .855-.402.855-.898s-.383-.898-.855-.898c-.473 0-.856.402-.856.898s.383.898.856.898Z"
      fill="#fff"
    />
  </svg>
);

const tiktokIcon = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.98 6.018C17.173 6 18.355 6.01 19.543 6c.035 1.3.607 2.541 1.596 3.473A6.737 6.737 0 0 0 25 10.964v3.36a10.465 10.465 0 0 1-3.827-.81 11.76 11.76 0 0 1-1.476-.772c-.01 2.432.01 4.869-.02 7.292a6.042 6.042 0 0 1-1.227 3.282c-1.228 1.623-3.225 2.619-5.387 2.678a7.137 7.137 0 0 1-3.718-.86c-1.868-1.013-3.1-2.777-3.324-4.76-.02-.418-.03-.831-.01-1.24.373-3.446 3.732-5.965 7.504-5.624.15.014.298.032.447.055.02 1.232-.034 2.468-.034 3.7-1.63-.523-3.415.26-3.986 1.75 0 .005 0 .01-.005.014a3.075 3.075 0 0 0-.13 1.341c.244 1.423 1.616 2.45 3.191 2.391 1.034-.027 1.983-.531 2.525-1.34.204-.26.333-.564.373-.883.089-1.49.054-2.977.064-4.468.01-3.36-.01-6.71.02-10.06v.008Z"
      fill="#fff"
    />
  </svg>
);

const youtubeIcon = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.582 20.814a2.505 2.505 0 0 1-1.768 1.768C22.254 23 16 23 16 23s-6.255 0-7.814-.418a2.505 2.505 0 0 1-1.768-1.768C6 19.254 6 16 6 16s0-3.254.418-4.814c.23-.86.908-1.538 1.768-1.768C9.746 9 16 9 16 9s6.255 0 7.814.418c.86.23 1.538.908 1.768 1.768C26 12.745 26 16 26 16s0 3.254-.418 4.814Zm-11.628-7.769v5.91L19.182 16l-5.227-2.955Z"
      fill="#fff"
    />
  </svg>
);

const spotifyIcon = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 6C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10c0-5.522-4.477-10-10-10Zm4.586 14.423a.623.623 0 0 1-.857.207c-2.348-1.435-5.304-1.76-8.785-.964a.624.624 0 0 1-.277-1.216c3.809-.87 7.076-.495 9.712 1.116.294.18.387.563.207.857ZM21.81 17.7a.78.78 0 0 1-1.072.257c-2.689-1.653-6.786-2.131-9.965-1.166a.78.78 0 0 1-.453-1.492c3.631-1.102 8.146-.568 11.233 1.329a.78.78 0 0 1 .257 1.072Zm.105-2.836c-3.223-1.914-8.54-2.09-11.618-1.156a.935.935 0 1 1-.543-1.79c3.533-1.072 9.405-.865 13.115 1.338a.934.934 0 1 1-.954 1.608Z"
      fill="#fff"
    />
  </svg>
);

const telegramIconLight = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.836 8.294c-.121-.138-.29-.213-.307-.22A.961.961 0 0 0 25.147 8c-.44-.008-.918.162-1.072.22-.243.081-.616.208-1.072.367-.797.28-1.385.504-1.608.587-.638.242-1.65.62-3.263 1.205l-3.991 1.615s-3.191 1.294-5.78 2.347c-.176.062-1.16.41-1.817.782-.135.075-.342.201-.459.44a.724.724 0 0 0-.076.44c.067.395.5.573.536.587 1.105.325 2.208.65 3.313.977.284.08.573.124.862.132a3.44 3.44 0 0 0 1.965-.549l7.004-4.555.94-.612c.315-.205.666.207.393.463l-.867.813-5.146 4.825a1.043 1.043 0 0 0 .165 1.657l4.627 2.928 1.72 1.088c.923.584 2.166.06 2.342-.987l.512-3.055.06-.359c.154-.85.304-1.716.449-2.592.195-1.188 1.09-7.21 1.107-7.518.03-.583-.013-.793-.153-.955l-.002.003Z"
      fill="#fff"
    />
  </svg>
);

const telegramIcon = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.836 8.294c-.121-.138-.29-.213-.307-.22A.961.961 0 0 0 25.147 8c-.44-.008-.918.162-1.072.22-.243.081-.616.208-1.072.367-.797.28-1.385.504-1.608.587-.638.242-1.65.62-3.263 1.205l-3.991 1.615s-3.191 1.294-5.78 2.347c-.176.062-1.16.41-1.817.782-.135.075-.342.201-.459.44a.724.724 0 0 0-.076.44c.067.395.5.573.536.587 1.105.325 2.208.65 3.313.977.284.08.573.124.862.132a3.44 3.44 0 0 0 1.965-.549l7.004-4.555.94-.612c.315-.205.666.207.393.463l-.867.813-5.146 4.825a1.043 1.043 0 0 0 .165 1.657l4.627 2.928 1.72 1.088c.923.584 2.166.06 2.342-.987l.512-3.055.06-.359c.154-.85.304-1.716.449-2.592.195-1.188 1.09-7.21 1.107-7.518.03-.583-.013-.793-.153-.955l-.002.003Z"
      fill="#000"
    />
  </svg>
);

const xIcon = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.567 14.793 22.827 9h-1.941l-4.191 4.636L12.97 9H8l6.187 7.758L8.567 23h1.881l4.61-5.084L19.152 23H24l-6.434-8.207Zm2.084 6.665-8.673-10.975h1.44l8.673 10.975h-1.44Z"
      fill="#000"
    />
  </svg>
);

const mailIcon = (
  <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 8h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Zm16.5 2.5a.75.75 0 0 0-1.055-.117l-6.289 5.031a.25.25 0 0 1-.312 0l-6.289-5.031a.75.75 0 1 0-.938 1.172l6.29 5.031a1.75 1.75 0 0 0 2.186 0l6.29-5.031A.75.75 0 0 0 23.5 10.5Z"
      fill="#000"
    />
  </svg>
);

const pintrestIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
    <path
      fill="#000"
      fillRule="evenodd"
      d="M14 24c5.523 0 10-4.477 10-10S19.523 4 14 4 4 8.477 4 14c0 4.413 2.858 8.158 6.824 9.485a.412.412 0 0 0 .252.08A10 10 0 0 0 14 24Zm-2.924-.434a.52.52 0 0 0 .434-.27c.256-.449.564-1.003.735-1.391.171-.379.3-.731.391-1.077.097-.365.19-.726.284-1.087.085-.33.17-.66.258-.993.504.67 1.299 1.005 2.2.988a4.37 4.37 0 0 0 3.049-1.188 5.94 5.94 0 0 0 1.44-2.087c.42-1.038.617-2.286.5-3.405-.183-1.988-1.482-3.684-3.277-4.494-1.796-.814-4.122-.723-5.905.137a5.57 5.57 0 0 0-2.101 1.764c-1.394 1.932-1.518 4.805.069 6.63.22.255.479.46.767.613a.548.548 0 0 0 .244.078c.167 0 .23-.16.265-.3.042-.167.081-.332.12-.497l.12-.496a.43.43 0 0 0-.076-.375 3.6 3.6 0 0 1-.657-2.643c.228-2.144 2.04-3.652 4.176-3.636 1.76-.04 3.393.99 3.84 2.742.522 1.966-.338 5.416-2.776 5.483-.937 0-1.643-.809-1.356-1.742.083-.296.17-.595.256-.887l.037-.128c.1-.343.203-.695.3-1.044.169-.571.3-1.301.02-1.868a1.182 1.182 0 0 0-1.097-.669c-.847.02-1.437.624-1.692 1.474-.23.761-.178 1.527.1 2.286.046.124.017.235-.013.351-.093.392-.183.786-.274 1.18-.212.92-.425 1.843-.661 2.767-.258 1.016-.306 2.046-.189 3.113.005.04.004.084.003.14a.54.54 0 0 0 .083.303.497.497 0 0 0 .131.147c.084.028.168.055.252.08Z"
      clipRule="evenodd"
    />
  </svg>
);

const pintrestIconDark = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14 24c5.523 0 10-4.477 10-10S19.523 4 14 4 4 8.477 4 14c0 4.413 2.858 8.158 6.824 9.485a.412.412 0 0 0 .252.08A10 10 0 0 0 14 24Zm-2.924-.434a.52.52 0 0 0 .434-.27c.256-.449.564-1.003.735-1.391.171-.379.3-.731.391-1.077.097-.365.19-.726.284-1.087.085-.33.17-.66.258-.993.504.67 1.299 1.005 2.2.988a4.37 4.37 0 0 0 3.049-1.188 5.94 5.94 0 0 0 1.44-2.087c.42-1.038.617-2.286.5-3.405-.183-1.988-1.482-3.684-3.277-4.494-1.796-.814-4.122-.723-5.905.137a5.57 5.57 0 0 0-2.101 1.764c-1.394 1.932-1.518 4.805.069 6.63.22.255.479.46.767.613a.548.548 0 0 0 .244.078c.167 0 .23-.16.265-.3.042-.167.081-.332.12-.497l.12-.496a.43.43 0 0 0-.076-.375 3.6 3.6 0 0 1-.657-2.643c.228-2.144 2.04-3.652 4.176-3.636 1.76-.04 3.393.99 3.84 2.742.522 1.966-.338 5.416-2.776 5.483-.937 0-1.643-.809-1.356-1.742.083-.296.17-.595.256-.887l.037-.128c.1-.343.203-.695.3-1.044.169-.571.3-1.301.02-1.868a1.182 1.182 0 0 0-1.097-.669c-.847.02-1.437.624-1.692 1.474-.23.761-.178 1.527.1 2.286.046.124.017.235-.013.351-.093.392-.183.786-.274 1.18-.212.92-.425 1.843-.661 2.767-.258 1.016-.306 2.046-.189 3.113.005.04.004.084.003.14a.54.54 0 0 0 .083.303.497.497 0 0 0 .131.147c.084.028.168.055.252.08Z"
      clipRule="evenodd"
    />
  </svg>
);

export {
  facebookIcon,
  facebookIconLight,
  instagramIcon,
  mailIcon,
  pintrestIcon,
  pintrestIconDark,
  spotifyIcon,
  telegramIcon,
  telegramIconLight,
  tiktokIcon,
  whatsappIcon,
  whatsappIconLight,
  xIcon,
  youtubeIcon,
};
